import { render, staticRenderFns } from "./thumbs-slider.vue?vue&type=template&id=4589c9a8&scoped=true&"
import script from "./thumbs-slider.vue?vue&type=script&lang=js&"
export * from "./thumbs-slider.vue?vue&type=script&lang=js&"
import style0 from "./thumbs-slider.vue?vue&type=style&index=0&id=4589c9a8&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4589c9a8",
  null
  
)

export default component.exports